module.exports = __webpack_public_path__ + "static/media/isadora-helena.0ce16699.jpeg";